export const setCookieConsent = (enabled) => {
  localStorage.setItem('cookie-consent', enabled);
};

export const getCookieConsent = () => localStorage.getItem('cookie-consent');

export const hasChosenCookieOption = () => getCookieConsent() !== null;

export const areCookiesAllowed = () => hasChosenCookieOption() && getCookieConsent() === 'true';
